import {
  CHEF_ASSET,
  CHOP_CHEF,
  GINGER_CHILLI,
  GROUPING_BAG,
  GROUPING_BAG_BALANCED,
  MILIJULI,
  PAV_BHAJI_PACKET,
  THREE_D_PHONE,
  VEN_PONGAL,
} from '@utils/data';
import { CarouselType, howItsWorkParallaxSection } from '@utils/types';

const carouselContent: CarouselType[] = [
  {
    id: '1',
    icon: GINGER_CHILLI,
    alt: 'GINGER_CHILLI',
    title: 'Authentic Indian Flavors',
    subtitle:
      'This is Indian food the way it would taste at the source, using all-natural ingredients specific to each dish’s place of origin.',
    priority: true,
  },
  {
    id: '2',
    icon: CHEF_ASSET,
    alt: 'CHEF_ASSET',
    title: 'Expert Chef-Prepared',
    subtitle:
      'Our team of expert chefs hail from all over India and bring their expertise into curating our menu with true local flavors.',
  },
  {
    id: '3',
    icon: PAV_BHAJI_PACKET,
    alt: 'PAV_BHAJI_PACKET',
    title: 'Clean Food, Always',
    subtitle:
      'Freeze drying technology ensures that our meals have a long shelf life and retain every bit of flavor and nutrition without using any additives.',
  },
];

const MiddleSectionContent: CarouselType[] = [
  {
    id: '1',
    icon: THREE_D_PHONE,
    alt: 'THREE_D_PHONE',
    title: 'Pick your plan and meals',
    subtitle:
      'Customize your meal plan with a chef-curated menu of Indian dishes. Everything is vegetarian, all-natural, and starts at just $4.99!',
  },
  {
    id: '2',
    icon: GROUPING_BAG,
    alt: 'GROUPING_BAG',
    title: 'Receive your meal delivery',
    subtitle:
      'Get your meals delivered to your doorstep for no delivery fees! Need to skip a week, change meals, or cancel? No problem.',
  },
  {
    id: '3',
    icon: MILIJULI,
    alt: 'MILIJULI',
    title: 'Delicious food ready in 5 minutes',
    subtitle:
      'Just add hot water to the contents of your Cumin Club packet, prep your chosen sides, and in just a few minutes, our meal is ready to eat!',
  },
];

export { carouselContent, MiddleSectionContent };
